$(document).ready(function () {
    $('.article .text-area .figure-extra-full').each(function(){
        if ($(window).width() > 991) {
            const figure = $(this)
            const articleInfoHeight = $('.article .article__info').height()
            const figureDistance = figure.position().top - figure.parent().position().top + 64
    
            if(figureDistance <= articleInfoHeight){
                var prevElementDistance = 0
                var initialMargin = 0
    
                if(figure.is(':first-child') == false){
                    prevElementDistance = (figure.prev().position().top + figure.prev().outerHeight(true)) - figure.parent().position().top
                    initialMargin = articleInfoHeight - prevElementDistance + 74
        
                } else {
                    initialMargin = articleInfoHeight + 32
                }
    
                figure.css('margin-top', initialMargin)
            }
         }
    })
});
